import axios from "axios"

/* Get Token */
export const getToken = (serviceURL, data) => {
    const uri = `${serviceURL}/admin/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* View */
export const view = (serviceURL) => {
    const uri = `${serviceURL}/admin/view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Room View */
export const roomView = (serviceURL, data) => {
    const uri = `${serviceURL}/admin/room-view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Kick */
export const kick = (serviceURL, data) => {
    const uri = `${serviceURL}/admin/kick`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}